<section class="container menu-container">
    <app-card-image-layout [variant]="'rectangle'" [imageHeight]="'240px'"></app-card-image-layout>
    <app-card-image-layout [variant]="'rectangle'" [imageHeight]="'240px'"></app-card-image-layout>
    <app-card-image-layout [variant]="'rectangle'" [imageHeight]="'240px'"></app-card-image-layout>
    <app-card-image-layout [variant]="'rectangle'" [imageHeight]="'240px'"></app-card-image-layout>
    <app-card-image-layout [variant]="'rectangle'" [imageHeight]="'240px'"></app-card-image-layout>
    <app-card-image-layout [variant]="'rectangle'" [imageHeight]="'240px'"></app-card-image-layout>
</section>
